/*
 * cadabra-header-enhancements.js
 * ----------------------------------------------------------------------------
 * Header UX enhancements injected without touching sections/header.liquid.
 *
 *   1. Primary CTA pair    — "Register Business" and "Talk to Sales"
 *   2. Cart-drawer a11y    — toggles aria-hidden / inert on <cart-drawer>
 *   3. Tile flyout URLs    — rewrites Top Sellers, New Arrivals and Clearance
 *                            flyout links to use dedicated category collections
 *                            with tile-appropriate sort order.
 *
 * Category matching (most-to-least reliable):
 *   a) filter.p.product_type from the original link query string
 *   b) Exact link text content
 *   c) Normalise & → and, case-insensitive
 * ----------------------------------------------------------------------------
 */

(function () {
  'use strict';

  var CART_DRAWER_TAG = 'cart-drawer';

  // ---------------------------------------------------------------------------
  // Product-type value → collection handle
  // ---------------------------------------------------------------------------
  var PRODUCT_TYPE_TO_HANDLE = {
    'Networking':        'networking-1',
    'Access Control':    'access-control-1',
    'Fire and Safety':   'fire-safety-1',
    'Fire & Safety':     'fire-safety-1',
    'AV Equipment':      'type-av-equipment',
    'Cable':             'type-cable',
    'Content Creation':  'type-content-creation',
    'Gaming':            'type-gaming',
    'Home Security':     'type-home-security',
    'Lifestyle Gadgets': 'type-lifestyle-gadgets',
    'Office Security':   'type-office-security',
    'PA System':         'type-pa-system',
    'Smart Home':        'type-smart-home'
  };

  // ---------------------------------------------------------------------------
  // Tile configuration — keyed by the EXACT text in .cad-tile__nm
  // Both "Clearance" and "Clearance Sale" are listed so either works.
  // ---------------------------------------------------------------------------
  var TILE_CONFIG = {
    'New Arrivals':  { mainUrl: '/collections/new-arrivals',   sortParam: '?sort_by=created-descending', isClearance: false },
    'Top Sellers':   { mainUrl: '/collections/top-sellers',    sortParam: '?sort_by=best-selling',       isClearance: false },
    'Clearance':     { mainUrl: '/collections/clearance-sale', sortParam: null,                          isClearance: true  },
    'Clearance Sale':{ mainUrl: '/collections/clearance-sale', sortParam: null,                          isClearance: true  }
  };

  // ---------------------------------------------------------------------------
  // Resolve a flyout <a> to a collection handle.
  // ---------------------------------------------------------------------------
  function resolveHandle(a) {
    // 1. Parse filter.p.product_type from the original href
    try {
      var qs = a.search || '';
      var m = qs.match(/[?&]filter\.p\.product_type=([^&]+)/);
      if (m) {
        var decoded = decodeURIComponent(m[1].replace(/\+/g, ' '));
        if (PRODUCT_TYPE_TO_HANDLE[decoded]) return PRODUCT_TYPE_TO_HANDLE[decoded];
      }
    } catch (e) {}

    // 2. Exact text match
    var text = a.textContent.trim();
    if (PRODUCT_TYPE_TO_HANDLE[text]) return PRODUCT_TYPE_TO_HANDLE[text];

    // 3. Normalise & → and, case-insensitive
    var norm = text.replace(/\s*&\s*/g, ' and ');
    for (var key in PRODUCT_TYPE_TO_HANDLE) {
      if (key.toLowerCase() === norm.toLowerCase()) return PRODUCT_TYPE_TO_HANDLE[key];
    }

    return null;
  }

  // ---------------------------------------------------------------------------
  // Tile flyout URL rewriting
  // ---------------------------------------------------------------------------
  function fixTileFlyoutLinks() {
    document.querySelectorAll('li.cad-tile-li').forEach(function (li) {
      var nm = li.querySelector('.cad-tile__nm');
      if (!nm) return;
      var tileName = nm.textContent.trim();
      var cfg = TILE_CONFIG[tileName];
      if (!cfg) return;

      li.querySelectorAll('.cad-cat-flyout a').forEach(function (a) {
        if (cfg.isClearance) {
          // Clearance only has 6 products across 3 types — send all
          // category clicks to the full clearance page rather than
          // per-category pages that would mostly be empty.
          a.href = cfg.mainUrl;
          return;
        }
        var handle = resolveHandle(a);
        if (handle) {
          a.href = '/collections/' + handle + (cfg.sortParam || '');
        }
      });

      var tileAnchor = li.querySelector('a.cad-tile');
      if (tileAnchor) tileAnchor.href = cfg.mainUrl;
    });
  }

  // ---------------------------------------------------------------------------
  // Element builders
  // ---------------------------------------------------------------------------
  function makeCTAs() {
    var wrap = document.createElement('div');
    wrap.className = 'cadabra-header-ctas';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Primary actions');
    wrap.innerHTML =
      '<a class="btn btn-color cadabra-header-ctas__quote" href="/pages/enterprise-procurement">' +
        '<span>Register Business</span>' +
      '</a>' +
      '<a class="btn btn--secondary cadabra-header-ctas__sales" href="https://zbooking.in/DtLNb" target="_blank" rel="noopener">' +
        '<span>Talk to Sales</span>' +
      '</a>';
    return wrap;
  }

  // ---------------------------------------------------------------------------
  // Header insertion
  // ---------------------------------------------------------------------------
  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) return true;
    var node = el;
    while (node && node.tagName !== 'BODY') {
      if (getComputedStyle(node).display === 'none') return false;
      node = node.parentElement;
    }
    return true;
  }

  function pickVisible(nodeList) {
    for (var i = 0; i < nodeList.length; i++) if (isVisible(nodeList[i])) return nodeList[i];
    return nodeList[0] || null;
  }

  function findHeaderUtilityArea() {
    var cartCandidates = document.querySelectorAll(
      'header #cart-icon-bubble, sticky-header #cart-icon-bubble, header a[href$="/cart"], sticky-header a[href$="/cart"]'
    );
    var cartLink = pickVisible(cartCandidates);
    if (cartLink) return { container: cartLink.parentElement, cartLink: cartLink };
    var actionCandidates = document.querySelectorAll(
      '.header__icons, .header__actions, header .grid > :last-child'
    );
    return { container: pickVisible(actionCandidates), cartLink: null };
  }

  function findMobileMenuRoot() {
    return (
      document.querySelector('menu-drawer .menu-drawer__inner-container') ||
      document.querySelector('menu-drawer') ||
      document.querySelector('.menu-drawer') ||
      document.querySelector('.mobile-menu') ||
      null
    );
  }

  function injectHeader() {
    if (document.querySelector('.cadabra-header-ctas')) return;
    var spot = findHeaderUtilityArea();
    if (!spot || !spot.container) return;
    var ctas = makeCTAs();
    spot.container.insertBefore(ctas, spot.container.firstChild);
    var drawer = findMobileMenuRoot();
    if (drawer) {
      var mobileCTAs = makeCTAs();
      mobileCTAs.classList.add('cadabra-header-ctas--mobile');
      drawer.appendChild(mobileCTAs);
    }
  }

  // ---------------------------------------------------------------------------
  // Cart drawer a11y
  // ---------------------------------------------------------------------------
  function setupCartDrawerA11y() {
    var drawer = document.querySelector(CART_DRAWER_TAG);
    if (!drawer) return;
    setClosed(drawer);
    var observer = new MutationObserver(function () {
      var visible =
        drawer.classList.contains('active') ||
        drawer.classList.contains('is-open') ||
        drawer.getAttribute('open') !== null ||
        getComputedStyle(drawer).visibility === 'visible';
      if (visible) setOpen(drawer); else setClosed(drawer);
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'open', 'data-open'] });
    window.cadabraOpenCart = function () {
      if (typeof drawer.open === 'function') drawer.open();
      setOpen(drawer);
    };
  }

  function setOpen(el)   { el.removeAttribute('aria-hidden'); el.removeAttribute('inert'); }
  function setClosed(el) { el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', ''); }

  // ---------------------------------------------------------------------------
  // Bootstrap
  // ---------------------------------------------------------------------------
  function ready(fn) {
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    injectHeader();
    setupCartDrawerA11y();
    fixTileFlyoutLinks();
    setTimeout(injectHeader, 600);
    setTimeout(fixTileFlyoutLinks, 500);
    setTimeout(fixTileFlyoutLinks, 1500);
  });
})();
